module.exports = __webpack_public_path__ + "static/media/success.f744db7d.svg";